import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { ComponentParams } from '@sitecore-jss/sitecore-jss-react';
import { BACKGROUND_COLOR_MAP } from '../../../constants/background-color.constants';
import {
  TCHSeriesDetailNavigationSectionFields,
  TCHSeriesDetailNavigationSectionInnerComponents,
  TCHSeriesDetailNavigationSectionProps,
} from '../types/productSeriesDetailNavigationOverviewSection.types';

export class CHSeriesDetailNavigationSectionModel {
  private readonly fields: TCHSeriesDetailNavigationSectionFields;
  private readonly rendering?: ComponentRendering;
  private readonly params: ComponentParams;

  constructor(props: TCHSeriesDetailNavigationSectionProps) {
    this.fields = props?.fields || null;
    this.params = props?.params || null;
    this.rendering = props?.rendering;
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get innerComponents(): TCHSeriesDetailNavigationSectionInnerComponents[] {
    const innerComp = this.fields?.apiData?.innerComponents;
    innerComp && innerComp.splice(4);
    return innerComp && innerComp?.length ? innerComp : [];
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get backgroundColor(): string | undefined {
    return BACKGROUND_COLOR_MAP.get(this.params?.backgroundColor || '');
  }
}
